import React from 'react';
import "../Figure.css"


function Figure11() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (30min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 1.41 mg/L </td>
              <td> 1.2 mg/L </td>
              <td> 0 mg/L </td>
            </tr> 
            <tr>
              <th> EC20 </th>
              <td> 0.39 mg/L </td>
              <td> 0.1 mg/L </td>
              <td> 1.1 mg/L </td>
            </tr>
            <tr>
              <th> SpaC </th>
              <td> 0.74 mg/L </td>
              <td> 0.48 mg/L </td>
              <td> 0.72 mg/L </td>
            </tr>
            <tr>
              <th className="colored-cell" colSpan="3"> Uptake difference </th>
              <th className="colored-cell">0.38 mg/L</th>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure11;